<div
  class="bg d-flex align-items-center pb-2 {{ classesContent() }}"
  [style.backgroundImage]="'url(' + imageBackground() + ')'"
>
  <div class="text-left">
    @if (title()) {
      <p class="text-white fs-6 mb-1">{{ title() }}</p>
    }
    @if (subtitle()) {
      <p class="text-white fs-6 mb-0">{{ subtitle() }}</p>
    }
  </div>
  <div class="d-flex flex-column ms-3 row-gap-1">
    <button class="bg-transparent border-0 p-0">
      <img (click)="clickAndroid()" [lazyLoad]="imageAndroid() || ''" class="img-fluid" />
    </button>
    <button class="bg-transparent border-0 p-0">
      <img (click)="clickIos()" [lazyLoad]="imageIos() || ''" class="img-fluid" />
    </button>
  </div>
</div>
